var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.124 64.125C51.588 64.125 64.124 51.589 64.124 36.125C64.124 20.661 51.588 8.125 36.124 8.125C20.6601 8.125 8.12402 20.661 8.12402 36.125C8.12402 51.589 20.6601 64.125 36.124 64.125Z",
    stroke: "#98692C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1236 51.5246C44.6288 51.5246 51.5236 44.6298 51.5236 36.1246C51.5236 27.6194 44.6288 20.7246 36.1236 20.7246C27.6184 20.7246 20.7236 27.6194 20.7236 36.1246C20.7236 44.6298 27.6184 51.5246 36.1236 51.5246Z",
    stroke: "#CBA66E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.124 0.125L43.124 36.125L36.124 72.125L29.124 36.125L36.124 0.125Z",
    fill: "url(#paint0_linear_428_27)",
    stroke: "#330804",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.124023 36.125L36.124 29.125L72.124 36.125L36.124 43.125L0.124023 36.125Z",
    fill: "url(#paint1_linear_428_27)",
    stroke: "#330804",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.124 41.125C38.8854 41.125 41.124 38.8864 41.124 36.125C41.124 33.3636 38.8854 31.125 36.124 31.125C33.3626 31.125 31.124 33.3636 31.124 36.125C31.124 38.8864 33.3626 41.125 36.124 41.125Z",
    fill: "#330804"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_428_27",
    x1: 29.124,
    y1: 0.125,
    x2: 56.1039,
    y2: 5.3711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CBA66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2922C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_428_27",
    x1: 0.124023,
    y1: 29.125,
    x2: 5.37012,
    y2: 56.1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CBA66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2922C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.ecba0c4795a8eeda28cff786f723a61c.svg";
export { ForwardRef as ReactComponent };